import { useTheme } from 'styled-components';

export default ({
  tabs = [],
  tabsDisplay = [],
  selectedTab,
  setSelectedTab,
  suppressBorderBottom,
  suppressSelectionBorderBottom,
  textStyle = {}
}) => {
  const theme = useTheme();

  return (
    <div style={{
      display: 'flex',
      paddingLeft: '20px',
      borderBottom: suppressBorderBottom ? 'none' : theme.borders.main
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        rowGap: '15px',
        columnGap: '15px',
        flexWrap: 'wrap'
      }}>
        {
          tabs.map((tab,i) => {
            const isSelected = selectedTab === tab;
            return (
              <div
                key={tab}
                style={{
                  padding: '8px 12px 6px 12px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  position: 'relative',
                  top: '1px',
                  ...textStyle,
                  color: isSelected ? theme.colors.primary : theme.colors.lightText,
                  borderBottom: suppressSelectionBorderBottom ? 'none' : (isSelected ? `2px solid ${theme.colors.primary}` : '2px solid transparent'),
                }}
                onClick={() => {
                  if (selectedTab !== tab) {
                    setSelectedTab(tab)
                  }
                }}
              >
                {tabsDisplay?.[i] || tab}
              </div>
            )
          })
        }
      </div>
    </div>
  )
}